import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import { setServio } from "../../../../../../redux/servioSlice";
import { RootState } from "../../../../../../redux/store";
import { DEFAULT_MAIN_COLOR } from "@constants/index";

import { Container, SectionTitle } from "./styled";
import { SourcesCard } from "./SourcesCard";
import {
    NotificationsState,
    OriginKey,
    OriginConfig,
    DEFAULT_ORIGINS,
} from "./types";

export function Notifications(): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const mainColor =
        useSelector((s: RootState) => s.global.infoUser.maincolor) ||
        DEFAULT_MAIN_COLOR;

    const reduxNotifications = useSelector(
        (s: RootState) => s.servio.notifications
    ) as Partial<NotificationsState>;

    const state: NotificationsState = React.useMemo(
        () => ({
            origins: {
                ...DEFAULT_ORIGINS,
                ...(reduxNotifications.origins || {}),
            },
        }),
        [reduxNotifications]
    );

    const [activeColorPicker, setActiveColorPicker] = React.useState<
        string | null
    >(null);

    const updateOrigin = (
        key: OriginKey,
        updates: Partial<OriginConfig>
    ): void => {
        dispatch(
            setServio({
                notifications: {
                    origins: {
                        ...state.origins,
                        [key]: { ...state.origins[key], ...updates },
                    },
                },
            })
        );
    };

    const resetOrigins = (): void => {
        dispatch(
            setServio({ notifications: { origins: { ...DEFAULT_ORIGINS } } })
        );
    };

    return (
        <Container data-testid="servio-notifications-tab">
            <div>
                <SectionTitle>{t("Notifications")}</SectionTitle>
            </div>

            <SourcesCard
                origins={state.origins}
                mainColor={mainColor}
                activeColorPicker={activeColorPicker}
                setActiveColorPicker={setActiveColorPicker}
                onUpdateOrigin={updateOrigin}
                onReset={resetOrigins}
            />
        </Container>
    );
}
